import { RELOAD_PAGE } from '../actions/reload-page';

export function reloadPage(state = false, action) {
  if (action.type === RELOAD_PAGE) {
    return true;
  } else {
    return state;
  }
}
